import { useState, useEffect, useRef } from "react";
import { debounce } from "lodash";
import ReferralSelectComponent from "./ReferralSelect";
import AddFromWithMember from "./AddFormWithMember";
import {
  createReferral,
  getReferral,
  updateReferral,
} from "containers/referrals/api";
const { DEBOUNCE_DELAY, initialMetaForTable } = require("constants/common");
const { getMembers } = require("containers/members/api");

const useDebouncedDataCallback = () => {
  const debouncedFetch = useRef(
    debounce(async (inputValue, callback) => {
      try {
        const response = await getMembers({
          search: inputValue,
          mif_status: "all",
          history: true,
        });
        let formattedOptions = response?.members?.map((el) => ({
          ...el,
          value: el.id,
          label: el.name,
          cin: el.cin,
        }));

        if (!formattedOptions || formattedOptions.length === 0) {
          callback([]); // Ensure empty array is returned
        } else {
          callback(formattedOptions);
        }
      } catch (error) {
        console.error("Failed to fetch members:", error);
        callback([]);
      }
    }, DEBOUNCE_DELAY)
  ).current;

  return debouncedFetch;
};

const AddReferralsList = ({
  handleOpenNewReferralForm,
  handleCloseAddModal = () => {},
  handleOpenThankyouNote = () => {},
  selectedReferral = "",
  setSelectedReferral = () => {},
  handleRefreshPage = () => {},
}) => {
  const [members, setMembers] = useState([]);
  const [selectedMember, setSelectedMember] = useState(null);
  const debouncedDataCallback = useDebouncedDataCallback();
  console.log("selectedReferral", selectedReferral);
  useEffect(() => {
    (async () => {
      const result = await getMembers({
        ...initialMetaForTable,
        page: 1,
        mif_status: "all",
        history: true,
      });
      // if (selectedReferral) {
      //   const result = await getReferral(selectedReferral.id);
      //   console.log("selected referral call >>>>", result);
      // }
      if (result?.members) {
        setMembers(result?.members);
        if (selectedReferral) {
          const findReferralInOption = members.find(
            (el) => el.id === selectedReferral.member.id
          );
          if (!findReferralInOption) {
            setMembers([...(result?.members || []), selectedReferral.member]);
          }
          setSelectedMember(selectedReferral.member);
        }
      }
    })();
  }, []);

  const handleAddReferral = async (values, setErrors = () => {}) => {
    let result = "";

    const { file_name, content_type, ...rest } = values;
    if (selectedReferral) {
      result = await updateReferral(
        {
          referral: {
            ...rest,
            member_id: selectedMember?.id,
          },
          attachment: rest.attachment,
          file_name,
          content_type,
        },
        selectedReferral.id,
        setErrors
      );
    } else
      result = await createReferral(
        {
          referral: {
            ...rest,
            member_id: selectedMember?.id,
          },
          attachment: rest.attachment,
          file_name,
          content_type,
        },
        setErrors
      );
    if (result) {
      handleCloseAddModal();
      handleOpenThankyouNote();
      handleRefreshPage();
    }
  };
  const noOptionsMessage = ({ inputValue }) => {
    if (!inputValue) return "Type to search members..."; // Handles the case where inputValue is undefined

    return (
      <div style={{ textAlign: "center", padding: "10px" }}>
        <strong>No results for "{inputValue}"</strong>
        <p>Check the spelling or try a new search</p>
        <button
          style={{
            backgroundColor: "#EAB308",
            color: "#000",
            border: "none",
            padding: "10px 20px",
            borderRadius: "8px",
            cursor: "pointer",
            marginTop: "10px",
          }}
          onClick={() => {
            handleCloseAddModal();
            handleOpenNewReferralForm();
          }}
        >
          Add New Member
        </button>
      </div>
    );
  };

  return (
    <>
      <ReferralSelectComponent
        label="Member"
        options={members.map((el) => ({
          ...el,
          value: el.id,
          label: el.name,
          avatar: true,
          cin: el.cin,
        }))}
        dataCallback={(inputValue) =>
          new Promise((resolve) => {
            debouncedDataCallback(inputValue, (options) => {
              if (!options || options.length === 0) {
                console.log(
                  "Returning an empty array to trigger noOptionsMessage"
                );
                resolve([]);
              } else {
                resolve(options);
              }
            });
          })
        }
        noOptionsMessage={noOptionsMessage}
        placeholder="Select Member"
        selectedValue={
          selectedReferral ? selectedReferral.member.id : selectedMember
        }
        handleChange={(obj) => {
          setSelectedReferral("");
          setSelectedMember(obj);
        }}
      />
      {selectedMember && (
        <AddFromWithMember
          selectedMember={selectedMember}
          handleAddReferral={handleAddReferral}
          handleCloseAddModal={handleCloseAddModal}
          selectedReferral={selectedReferral}
        />
      )}
    </>
  );
};

export default AddReferralsList;
